import React from "react";
import PieData from "./pie";
import BarData from "./bar";
import LineData from "./line";
import TableData from "./table";

function EchartsData(props) {
  const { type, data } = props;
  console.log(data);
  return (
    <>
      {type == "line" ? <LineData data={data} /> : undefined}
      {type == "bar" ? <BarData data={data} /> : undefined}
      {type == "pie" ? <PieData data={data} /> : undefined}
      {type == "table" ? <TableData data={data} /> : undefined}
    </>
  );
}

export default EchartsData;
